import { type WormholeList } from '../service';

type SiteMap = {
  [key: string]: string;
};

export const siteMap: SiteMap = {
  // 0: 'AWS',
  0: '中央站',
  // 1: '阿里云',
  1: '中国站',
  // 2: '欧洲',
  2: '欧洲站',
  3: '巴西站',
  // 4: '中央P2',
  4: '新中央P2站',
  // 5: '美国P1',
  5: '美国P1站',
  // 6: '中央P1',
  6: '新中央P1站',
};

const datacenterSort = [1, 2, 3, 5, 6, 4];

export const formatWormholeList = (wormholeList: WormholeList[], path = '') => {
  return datacenterSort
    .map(item => {
      const foundItem = wormholeList.find(
        obj => obj.site_location === item && obj.site_flag && obj.site_url,
      );
      if (foundItem) {
        return {
          ...foundItem,
          site_url: `${new URL(foundItem.site_url).origin}${path}`,
          data_center: siteMap[foundItem.site_location.toString()],
          path,
        };
      }
      return null;
    })
    .filter(Boolean) as WormholeList[];
};
